export class LabelPrinterPrintLogCreateDto {
  labelPrinterGuid?: string = undefined
  labelTypeGuid?: string = undefined
  vehicleGuid?: string = undefined
  labelPrintContextTypeGuid?: string = undefined
  selectedBluetoothDeviceName?: string = undefined
  wasSuccessful?: boolean = undefined
  errorMessage?: string = undefined
  errorName?: string = undefined
  errorStack?: string = undefined
  browserUserAgent?: string = undefined
  bluetoothServiceUuid?: string = undefined
  bluetoothCharacteristicUuid?: string = undefined
  platformProfile?: string = undefined
  writeMethodUsed?: string = undefined
  chunkSize?: number = undefined
  chunkDelayMs?: number = undefined
  finalPrintDrainDelayMs?: number = undefined
  totalChunks?: number = undefined
  prnLooksLikeZpl?: boolean = undefined
  prnLooksLikeCpcl?: boolean = undefined
  statusProbeAttempted?: boolean = undefined
  statusProbeSucceeded?: boolean = undefined
  statusProbeResponsePreview?: string = undefined
  failedChunkIndex?: number = undefined
  failedByteOffset?: number = undefined
  bytesAttempted?: number = undefined
  bytesSent?: number = undefined
  bluetoothFailureStage?: string = undefined
  gattConnectAttempts?: number = undefined
  gattReconnectAttempts?: number = undefined
  gattOperationRetries?: number = undefined
}
